import React, { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const UnrealizedProfitCardSkeleton: FC = () => {
  return (
    <DashboardCard
      sx={{
        justifyContent: 'space-between',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Title */}
      <Skeleton variant="text" width={120} height={20} sx={{ mb: 2 }} />

      {/* Content */}
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          width: '100%',
        }}
      >
        {/* Statistic value */}
        <Skeleton variant="text" width={100} height={32} />

        {/* Mini chart area */}
        <Box
          sx={{
            width: 60,
            height: 40,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 0.5,
          }}
        >
          {/* Simulate mini line chart with bars */}
          {[12, 8, 15, 20, 18, 25, 22, 16].map((height, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={6}
              height={height}
              sx={{ borderRadius: 0.5 }}
            />
          ))}
        </Box>
      </Stack>
    </DashboardCard>
  );
};
